import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { UpdateEmailCycleRPC } from "./updateEmailCycleRPC";

export class UpdateEmailCycleRPCClientImpl extends UpdateEmailCycleRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: UpdateEmailCycleRPC.Request): Promise<LeoRPCResult<UpdateEmailCycleRPC.Response, UpdateEmailCycleRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "email-cycle/UpdateEmailCycle",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      UpdateEmailCycleRPC.ResponseDTO,
      UpdateEmailCycleRPC.Errors.ErrorsDTO,
      UpdateEmailCycleRPC.Response,
      UpdateEmailCycleRPC.Errors.Errors
    >(
      response,
      "email-cycle/UpdateEmailCycle",
      UpdateEmailCycleRPC.Response.fromDTO,
      UpdateEmailCycleRPC.Errors.fromDTO
    );
  }
}
